import { SvgIcon, SvgIconProps } from '@mui/material';

export const ArrowLeft = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 20 16" {...props}>
      <path
        d="M8 1L1 7.99993M1 7.99993L8 14.9999M1 7.99993H19"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
